import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { FileSearch, ClipboardList, PackageCheck, BadgeCheck } from "lucide-react";

const ICONS = [FileSearch, ClipboardList, PackageCheck, BadgeCheck];

export default function HowItWorks({ onCta }) {
  const { t } = useLang();
  const steps = [1, 2, 3, 4].map((n) => ({
    t: t(`steps.${n}t`), s: t(`steps.${n}s`), d: t(`steps.${n}d`), b: t(`steps.${n}b`),
  }));
  return (
    <section id="come-funziona" className="py-20 lg:py-28 bg-white" data-testid="how-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }} className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#00AEEF]">{t("steps.kicker")}</p>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#003087] mt-3">{t("steps.title")}</h2>
          <p className="mt-4 text-base text-[#64748B]">{t("steps.sub")}</p>
        </motion.div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.6, delay: i * 0.15 }}
                className="card relative rounded-3xl p-8"
                data-testid={`how-step-${i + 1}`}
              >
                <div className="flex items-center justify-between">
                  <span className="text-5xl font-extrabold text-[#E6F6FD] select-none">0{i + 1}</span>
                  <div className="w-12 h-12 rounded-2xl bg-[#00AEEF]/10 border border-[#00AEEF]/25 flex items-center justify-center">
                    <Icon size={21} className="text-[#00AEEF]" />
                  </div>
                </div>
                <h3 className="text-xl font-bold text-[#003087] mt-5">{s.t}</h3>
                <p className="text-xs font-semibold uppercase tracking-wider text-[#00AEEF] mt-1.5">{s.s}</p>
                <p className="text-sm text-[#1A1A1A] leading-relaxed mt-4">{s.d}</p>
                <span className={`inline-block mt-6 text-xs font-bold rounded-full px-4 py-2 ${i === 3 ? "bg-[#00AEEF] text-white" : "bg-[#E6F6FD] text-[#003087]"}`}>
                  {s.b}
                </span>
                {i === 0 && (
                  <button data-testid="how-step1-cta" onClick={() => onCta("visure")} className="btn-green block w-full mt-5 rounded-full py-3 text-sm font-bold">
                    {t("pricing.p1.cta")}
                  </button>
                )}
                {i === 3 && (
                  <button data-testid="how-step4-cta" onClick={() => onCta("cancellazione")} className="btn-outline block w-full mt-5 rounded-full py-3 text-sm font-bold">
                    {t("pricing.p2.cta")}
                  </button>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
